module.exports = __webpack_public_path__ + "static/img/lifestyle_35.599a903a.png";